module.exports =  {
    common:{
        csApp:'Vita',
        laiKangApp:'Lefy',
        deleteAccountTip1:'1. Тіркелгіні APP арқылы жойыңыз немесе оны осы веб-сайттан жойыңыз. Жоюдан кейін жүйеге кіре алмайсыз.',
        deleteAccountTip2:'2. Пайдаланушы деректері жойылмайды. Пайдаланушылар тіркелгі деректерін жоймас бұрын тұтынушыларға қызмет көрсету орталығына қоңырау шалып, белгілі бір деректерді тексеруден өтуі керек.',
        account:'есептік жазба',
        password:'құпия сөз',
        deleteAccount:'Есептік жазбаны жою',
        accountValid:'Енгізілген шот нөмірі дұрыс екенін растаңыз',
        passwordValid:'Енгізілген құпия сөздің дұрыстығын растаңыз',
        accountAndPasswordValid:'Енгізілген есептік жазбаның немесе құпия сөздің дұрыстығын растаңыз',
        deleteAccountSuccess:'Есептік жазба сәтті жойылды',
        deleteAccountFail:'Есептік жазба жойылмады',
        date:'күні',
        time:'уақыт',
        hour:"h",
        min:"m",
        second:"s",
        day:"күні",
        week:"Апта",
        month:"Ай",
        year:"Жыл",
        dayUnit:"",
        weekUnit:"",
        monthUnitLast:"",
        monthUnit:"-",
        yearUnit:"-",
        detail:"Деталь",
        percent:"пайыз",
        percentUnit:"%",
        maxValue:'максималды мән',
        minValue:'ең төменгі мән',
        highest:"Ең жоғары",
        minimum:"Төмен",
        normal:"қалыпты",
        abnormal:"қалыптан тыс",
        normalPercent:"Қалыпты пропорция",
        abnormalPercent:"Қалыпты пропорция",
        numUnit:"",
        to:"~",
        formatDateYMD:"YYYY-MM-DD",
        formatDateMD:"MM-DD",
        formatDateYM:"YYYY-MM",
        formatDateM:"MM",
        formatDateYMDHM:"YYYY-MM-DD HH:mm",
        formatDateYMDHMS:"YYYY-MM-DD HH:mm:ss",
        formatDateMDHMS:"MM-DD HH:mm:ss",
        tip:"кеңес",
        confirm:"растау",
        cancel:"Болдырмау",
        noData:"Деректер жоқ",
        allDataLoadComplete:"Барлық деректер жүктелді",
        waiting:"Өтінемін күте тұрыңыз",
        contentLoading:"Мазмұн жүктелуде",
        noContainData:"Қатысты мазмұн жоқ",
        noNetwork:"Интернет жоқ",
        nowLoadingMoreData:"Сізге қосымша деректер жүктелуде. Күте тұрыңыз",
        monday: '1',
        tuesday: '2',
        wednesday: '3',
        thursday: '4',
        friday: '5',
        saturday: '6',
        sunday: '7',
        showAll:'барлығын көрсету',
        packUp:'жабық',
        showAllMore:'көбірек көрсету',
        packUpMore:'Көбірек жасыру',
        target:'Нысана',
        dontReachStandard:'N',
        reachStandard:'Y',
        totalDayNum:'Жалпы күндер',
        referenceValue:'Анықтама',  
        month1:'қаңтар',
        month2:'ақпан',
        month3:'наурыз',
        month4:'Сәуір',
        month5:'мамыр',
        month6:'маусым',
        month7:'шілде',
        month8:'тамыз',
        month9:'қыркүйек',
        month10:'қазан',
        month11:'қараша',
        month12:'желтоқсан',
        month1_long:'қаңтар',
        month2_long:'ақпан',
        month3_long:'наурыз',
        month4_long:'Сәуір',
        month5_long:'мамыр',
        month6_long:'маусым',
        month7_long:'шілде',
        month8_long:'тамыз',
        month9_long:'қыркүйек',
        month10_long:'қазан',
        month11_long:'қараша',
        month12_long:'желтоқсан', 
        peleaseSelect:'таңдаңыз',
 
        average:'орташа',
        numMinUnit:'рет/минут',
    },
    sport:{
        sport:'运动',
        sportReport:'运动报告',
        sportHrSet:'运动心率设置',

        sportType1:'户外跑步',
        sportType2:'室内跑步',
        sportType3:'户外步行',
        sportType4:'室内步行',
        sportType5:'户外骑行',
        sportType6:'室内单车',
        sportType7:'泳池游泳',
        sportType8:'开发水域',
        sportType9:'登山',
        sportType10:'徒步',
        sportType11:'越野跑',
        sportType12:'高尔夫练习',
        sportType13:'滑雪',
        sportType14:'雪板滑雪',
        sportType15:'越野滑雪',
        sportType16:'铁人三项',
        sportType17:'椭圆机',
        sportType18:'划船',
        sportType19:'跳绳',
        sportType20:'羽毛球',
        sportType21:'乒乓球',
        sportType22:'网球',
        sportType23:'篮球',
        sportType24:'足球',
        sportType25:'棒球',
        sportType26:'排球',
        sportType27:'板球',
        sportType28:'橄榄球',
        sportType29:'曲棍球',
        sportType30:'跳舞',
        sportType31:'动感单车',
        sportType32:'瑜伽',
        sportType33:'仰卧起坐',
        sportType34:'体操',
        sportType35:'开合跳',

        consume:'消耗',
        Pacing:'配速',
        Kilocalorie:'千卡',
        kilometre:'公里',

        sportStatistics:'活动统计',
        distanceAndUnit:'距离（公里）',
        distance:'距离',
        consumeAvg:'消耗（千卡）',
        pacingAvg:'平均配速（/公里）',
        cadenceAvg:'平均步频（步/分）',
        timeNum:'时长',
        totalStepNum:'总步数',

        step:'步数',
        stepReport:'步数报告',
        stepUnit:'步',
        stepAvg:'平均步数',
        
        stepconsume:'相当于消耗',
        stepStatistics:'步数统计',
        eggNum:'个鸡蛋',
       
        stepDistance:'相当于走了',
        stepDistanceNum:'圈标准操场',
        
        
    },
    sleep:{  
        sleep:'睡眠',
        sleepTime:'睡眠时长',
        deepSleep:'深睡',
        lightSleep:'浅睡',
        eyeMovement:'眼动',
        eyeMovementFast:'快速眼动',
        sober:'清醒',

        deepSleepAvg:'平均深睡',
        lightSleepAvg:'平均浅睡',
        eyeMovementFastAvg:'平均快速眼动',

        sleepStatistics:'睡眠统计',
        sleepNight:'夜间睡眠',
        sleepNightAvg:'平均夜间睡眠',
        deepSleepRate:'深睡比例',
        deepSleepRateAvg:'平均深睡比例',
        lightSleepRate:'浅睡比例',
        lightSleepRateAvg:'平均浅睡比例',
        eyeMovementFastRate:'快速眼动比例',
        eyeMovementFastRateAvg:'平均快速眼动比例',
        soberNumber:'清醒次数',
        soberNumberAvg:'平均清醒次数',

        sleepBeginTimeAvg:'平均入睡时间',
        sleepEndTimeAvg:'平均起床时间',
        
    },
    measure:{
        bloodOxygenTitle:"қандағы оттегі туралы есеп",
        bloodOxygen:"қандағы оттегі",
        bloodOxygenPercent:"Қанның оттегі күйінің қатынасы",
        bloodOxygenSaturation:"қанның оттегімен қанығуы",

        bloodOxygenSaturationTip1:"运动是促进血液循环和提高氧气水平的最好办法，如若本身有一些呼吸系统疾病，应选",
        bloodOxygenSaturationTip2:"择舒缓的运动，循序渐进提高血氧饱和度。",
        fingertip:"саусақ ұшы",
        wrist:"білек",
        fingertipBloodOxygenList:"Саусақ қанындағы оттегінің тізімі",
        wristBloodOxygenList:"Білек қанындағы оттегінің тізімі",
        bloodOxygenList:"қандағы оттегінің тізімі",
        
        bloodPressure:'қан қысымы',
        bloodPressureDetail:'Қан қысымы туралы мәліметтер',
        bloodPressureSys:'Жоғары',
        bloodPressureDia:'Төмен',
	
        mmHg:'mmHg',
        measurementStatistics:'Өлшеуім',
        measurementsTotalNumber:'Жалпы саны',
        measurementsNumber:'Жиілігі',
        bloodPressureMeasureTip1:'Оны бір рет таңертең 6:00-ден 8:00-ге дейін, ал күндіз 17:00-ден 19:00-ге дейін, кешке 20:00-ден 24:00-ге дейін ұйықтар алдында бақылау керек.',
        bloodPressureMeasureTip2:'Өлшеу алдында 5 минуттық үзіліс жасаңыз және әр жолы екі өлшем арасында 1 минуттық аралықпен екі қан қысымын өлшеңіз.',
        bloodPressureGoToMeasure:"立即测量",
        measurementsReachStandardDayNum:'测量达标天数',
        bloodPressureStatus:'血压状态',
        bloodPressureNormalNum:'正常血压次数',
        bloodPressureNormalHighNum:'正常高值血压次数',
        bloodPressureHighLevelOneNum:'1级高血压测量次数',
        bloodPressureHighLevelTwoNum:'2级高血压测量次数',
        bloodPressureStatistics:'血压统计',
        bloodPressureAverage:'血压平均值',
        bloodPressureLoadValue:'血压负荷值',
        bloodPressureAvgSys:'平均收缩压',
        bloodPressureAvgDia:'平均舒张压',
        bloodPressureDaySys:'日间收缩压',
        bloodPressureDayDia:'日间舒张压',
        bloodPressureNightSys:'夜间收缩压',
        bloodPressureNightDia:'夜间舒张压',
        bloodPressureNightDropRate:'夜间血压下降率',
        bloodPressureMeanArterialPressureAll:'平均(动脉)压[MAP]',
        bloodPressureMeanArterialPressure:'平均动脉压',
        bloodPressureCoefficientVariation:'血压变异系数（CV）',
        measureTime:'Басталу уақыты',
        measureBeginTime:'Басталу уақыты',
        measureEndTime:'Аяқталу уақыты',

        bloodPressureIndicators:'строгость',
        keepHealthAwayNibpTip:'减少盐的摄入量；平衡膳食；避免有害使用酒精；经常运动；以及避免使用烟草。',
        bloodPressureNormal:'Қалыпты',
        bloodPressureNormalHigh:'Биік',
        bloodPressureHighLevelOne:'Ауыр',
        bloodPressureHighLevelTwo:'өте ауыр',
        bloodPressureProtectAdvice:'血压保护建议',
        bloodPressureMeasureAdvice:'血压测量建议',
        day_avager:'Күнделікті орташа',  
        bloodPressureReport:'血压报告',
        bloodPressureReportExplain:'血压报告解析',
        bloodPressureReachDetail:'达标详情',
        explainDoctor:'解读医师',
        evaluate:'评估',
        reportProductSuccessTip:'您的报告生成提醒方式',
        messageTip:'短信提醒',
        reportProductIng:'您的报告还在分析中,',
        diagnosisApply:'申请诊断',
        reportProductNeedTime:'解析报告需要1-2个小时',
        reprotDayReachStandard:'日达标规则：当日6:00~8:00；17:00~19:00；20:00~ 24:00达到目标测量次数（每个时间段两次）。',
        reprotWeekReachStandard:'周达标规则：历史七日，每日测量达标三次则周达标。',
        
        reprotReachStandardAdvice1:'请您在从今天开始接下来三天',
        reprotReachStandardAdvice2:'的06:00~08:00,17:00~19:00,20:00~24:00各进行两次血压测量保证本周测量次数达标即可生成报告',
        reprotReachStandardAdvice3:'请您在今天和明天的06:00~08:00,17:00~19:00,20:00~24:00各进行两次血压测量保证本周测量次数达标即可生成报告',
        reprotReachStandardAdvice4:'请您在今天的17:00~19:00,20:00~24:00各进行两次血压测量保证本周测量次数达标即可生成报告',
        reprotReachStandardAdvice5:'请您在今天的20:00~24:00各进行两次血压测量保证本周测量次数达标即可生成报告',
        reprotReachStandardAdvice6:'请您在今天的06:00~08:00,17:00~19:00,20:00~24:00各进行两次血压测量保证本周测量次数达标即可生成报告',
        reprotReachStandardAdvice7:'请您在从明天开始接下来三天',
        reprotReachStandardAdvice8:'请您在从明天开始接下来两天',
        reprotReachStandardAdvice9:' 请您在明天的06:00~08:00,17:00~19:00,20:00~24:00各进行两次血压测量保证本周测量次数达标即可生成报告',
        reportductIng:'生成中',
        readed:'已读',
        unread:'未读',

        suanHuaGuideTip1:'如何进行血压的学习和测量',
        suanHuaGuideTip2:'心壁血压功能学习和测量中的注意事项',
        suanHuaGuideTip3:'如何进行血压的学习',
        suanHuaGuideTip4:'快速了解血压的学习，开启精准血压测量',
        suanHuaGuideTip5:'手表血压功能学习和测量中的注意事项',
        suanHuaGuideTip6:'如何通过APP换表盘',
        suanHuaGuideTip7:'快速了解表盘，开启多种表盘，每天一换',
        
        
        heartRate:'Жүрек соғу жиілігі',
        heartRateTitle:'心率报告',
        heartRateAvg:'平均心率',
        fingertipheartRateList:"指尖心率列表",
        wristheartRateList:"手腕心率列表",
        heartRateList:"心率列表",

        pressurePressureIndex:'压力指数',
        pressureTired:'疲劳度',
        pressureSpirePressure:'精神压力',
        pressureTolerance:'抗压能力',
        pressureTitle:'压力报告',
        good:     '良好',
        notBad:   '尚好',
        Moderate: '中等',
        poor:     '较差',
        easy:     '轻松',
        tired:    '较累',
        fatigue:  '疲劳',
        low:      '低',
        medium:   '中',
        high:     '高',
        veryHigh: '很高',
        lightHigh:'偏高',
        lightLow:'Төмен жағында',
        fast:'Тезірек',
        lightFast:'сәл жылдамырақ',
        lightSlow:'Жайрақ',
        



        
        temperature:'体温',
        temperatureReport:'体温报告',
        temperatureIndicators:'体温指标',
        
        measureDetailTip1Title:'测量前准备',
        measureDetailTip10:'*诊室测量血压要在适当空间、适宜温度（≈72°F／22℃）、安静无噪音的环境中。与被测者有关的诸多因素均可引起血压测量的偏差，如室内温度、运动、饮酒或吸烟、手臂位置、肌肉紧张、膀胱充盈、讲话和环境噪声等。受测者讲话是常见的因素，因此测压时受测者不要讲话，医护人员也不能与受测者讲话。',
        measureDetailTip11:'1.嘱患者放松，坐在椅子上，双脚平放地面上背靠椅背，大腿不宜交叠。初次测量前，应静坐＞5分钟，勿交谈和挪动。',
        measureDetailTip12:'2.在开始测量前至少30分钟内，避免运动、吸烟或喝咖啡。',
        measureDetailTip13:'3.确保患者排空膀胱。',
        measureDetailTip14:'4.测量血压的过程中，患者或医护人员都不要说话。',
        measureDetailTip15:'5.脱去覆盖袖带部位的衣服，充分裸露上臂，不应卷起袖子，这可能会产生止血带效应。',
        measureDetailTip2Title:'选择合适的设备 和 采取正确的测量方式',
        measureDetailTip21:'1.选择符合计量标准的水银柱血压计，或经过（ESH、BHS 和 AAMI）验证的上臂式电子血压计，确保血压计定期校准。',
        measureDetailTip22:'2.被测量者取坐位，最好坐靠背椅；裸露右上臂，肘部置于与心脏同一水平，被测者手臂自然地放在桌子上，不要握拳，因为肌肉动作可影响血压水平。',
        measureDetailTip23:'3.血压计应放在心脏水平。袖带的中部置于患者的上臂部位，与右心房水平平齐，相当于胸骨中点。',
        measureDetailTip24:'4.捆绑袖带：测量者须先扪及患者肘窝处的肱动脉，并将袖带气囊长轴中心（通常由制造商标记在袖带上）置于裸露上臂的动脉搏动之上。袖带的下端应距离肘窝上方 2 至 3厘米，留出放置听诊头的空间，位置与心脏（乳头水平）处于同一水平线上，袖带松紧度以能容下1-2指为宜。',
        measureDetailTip25:'5.使用大小合适的气囊袖带，采用合适大小的袖带，如气囊包绕上臂的75%~100%。肥胖者或臂围大者应使用大规格气囊袖带，儿童应使用小规格气囊袖带。',
        measureDetailTip26:'6.用水银血压计时将听诊器的探头置于肘窝肱动脉搏动处，不可置于袖带内',
        measureDetailTip3Title:'听诊法（水银血压计）测量规范',
        measureDetailTip31:'1.使用水银血压计进行测量时，测量者视线应与血压计表盘保持水平，匀速充气，气囊内压力应达到肱动脉搏动消失并再升高30mmHg，然后以恒定速率（2-6mmHg/S）缓慢放气。心率较慢时放气速率也较慢。获取舒张压读数后快速放气至零。',
        measureDetailTip32:'2.在放气过程中仔细听取柯氏音，观察柯氏音第I时相与第V时相汞柱凸面的垂直高度。 收缩压读数取柯氏音第I时相（第1音），舒张压读数取柯氏音第V时相（消失音）。',
        measureDetailTip33:'3.所有读数均应以水银凸面的顶端为准；读数应取偶数（0、2、4、6、8）。电子血压计以显示血压数据为准。',
        measureDetailTip34:'4.至少测量2次，应相隔1分钟重复测量，如果相邻2次的收缩压或舒张压的读数小于5mmhg，取2次的平均值，如果大于5mmhg，测量第3次，取3次的平均值。读取血压数值时，末位数只能为偶数。',
        measureDetailTip4Title:'血压测量频次',
        measureDetailTip401:'《2019中国家庭血压监测指南》',
        measureDetailTip402:'建议家庭血压监测时，应',
        measureDetailTip403:'每日早、晚',
        measureDetailTip404:'测量血压',
        measureDetailTip41:'1.每次测量应在坐位休息5 min后，测量2 ～ 3次，间隔 1 min。',
        measureDetailTip42:'2.初诊患者，治疗早期或虽经治疗但血压尚未达标患者，应于就诊前连续测量5 ～ 7 d ；血压',
        measureDetailTip43:'3.控制良好时，每周测量至少1 d。',
        measureDetailTip44:'4.早上血压测量应于起床后1 h内进行，服用降压药物之前，早餐前，剧烈活动前。晚间血压测量于晚饭后、上床睡觉前进行。',
        measureDetailTip45:'5.不论早上，还是晚上，测量血压前均应注意排空膀胱。',
        measureDetailTip46:'6.为了确保家庭血压监测的质量，血压监测期间应记录起床时间、上床睡觉时间、三餐时间及服药时间。',
        measureDetailTip5Title:'血压的生理变化',
        measureDetailTip51:'1.年龄：随着年龄的增长，舒张压和收缩压均有逐渐增高的趋势。',
        measureDetailTip52:'2.性别：女性，更年期前，低于男性；更年期后，血压升高，差别较小。',
        measureDetailTip53:'3.环境：寒冷环境，血压略有升高；高温环境，血压可略下降。',
        measureDetailTip54:'4.昼夜和睡眠：通常上午6~10时上升达高峰，午后14:00~15:00时下降，16:00~18:00时又上升达高峰，以后缓慢下降直至凌晨2~3是的最低谷值。休息和睡眠不佳时，血压稍增高。',
        measureDetailTip50:'* 血压波动也与测量的姿势、室内温度、吸烟、饮酒、手臂的位置、运动、讲话以及外部环境噪音等因素有关，需按照规定在平静状态下测量。',
        measureDetailTip6Title:'不同测量方法的高血压诊断标准',
        measureDetailTip7Title:'影响血压读数几大误区',
        measureDetailTip71:'1.膀胱充盈：即憋尿，可能导致血压读数约偏高10~15 mmHg。在测量血压之前，应排空膀胱。',
        measureDetailTip72:'2.坐姿不端正：包括懒散、背部或下肢缺乏支撑等情况，可能造成血压读数约偏高6~10 mmHg。测血压时，需背靠椅背、双脚平放在地板或脚凳上。',
        measureDetailTip73:'3.手臂悬空：可能导致血压读数约偏高10 mmHg。测量血压时，应将手臂平放在桌面上，使测量袖带水平与心脏平齐。',
        measureDetailTip74:'4.袖带套在衣服上：可能造成血压读数约偏高5~50 mmHg。测量血压时，隔衣厚度小于1 mm（如薄衬衣），最好能裸露手臂。',
        measureDetailTip75:'5.袖带太小太紧：可能导致血压读数约偏高2~10 mmHg。应选择大小合适的袖带。',
        measureDetailTip76:'6.翘腿：可能使血压读数约偏高2~8 mmHg。测量血压时不要翘腿，双脚平放支撑。',
        measureDetailTip77:'7.讲话：测量血压时受测者问问题、回答问题、打电话等现象，可能造成血压读数约偏高10 mmHg。测量血压时，注意不要说话，保持安静。',
        measureDetailTip8Title:'不同体位测量血压的差异',
        measureDetailTip81:'血压可在坐位、卧位、站立位等姿势下测量，然而一直以来高血压的诊断和治疗是以坐位血压为依据的，所以各指南中',
        measureDetailTip82:'推荐高血压患者的日常血压测量应在坐位进行。对于不方便坐位测量的患者，可躺着进行血压测量。',
        measureDetailTip83:'只要测量过程规范，无所谓哪个姿势测量更准确，反映的是不同姿势或体位下的人体血压。',
        measureDetailTip84:'坐位法血压值较卧位法降低约3mmHg；站立位测量较坐位降低约5mmHg，较卧位降低8mmHg。',
        measureDetailTip85:'即卧位＞坐位＞立位。',
        measureDetailTip86:'以上差异均具有统计学显著性。',
    }
}